
import Vue from 'vue';
import { Component, Emit } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import type { FilterCollection } from '@/stores/filter.store';
import WatchlistInnerTabNavigation from '@/components/watchlist/WatchlistInnerTabNavigation.vue';
import { CollectionType } from '@/enums/collection-type';
import { TabType } from '@/interfaces/inner-tabs';
import { ListsCollectionType } from '@/stores/routing.store';

const FollowedLists = () =>
	import(/* webpackChunkName: "followed-lists" */ '@/components/watchlist/public-lists/FollowedLists.vue');
const RecommendedLists = () =>
	import(/* webpackChunkName: "recommended-lists" */ '@/components/watchlist/public-lists/RecommendedLists.vue');
const PublicListDetails = () =>
	import(/* webpackChunkName: "public-list-details" */ '@/components/watchlist/public-lists/PublicListDetails.vue');

const Filter = namespace('filter');
const Routing = namespace('routing');

@Component({
	name: 'PublicLists',
	components: {
		PublicListDetails,
		FollowedLists,
		RecommendedLists,
		WatchlistInnerTabNavigation,
	},
})
export default class PublicLists extends Vue {
	@Filter.Getter(CollectionType.PUBLIC_LISTS) filterListsPublic: FilterCollection;
	@Routing.Action setLastActiveListsCollectionType: (lastActiveListsCollectionType: ListsCollectionType) => void;

	@Emit('scrollToTop')
	scrollToTop() {}

	created() {
		this.setLastActiveListsCollectionType(CollectionType.PUBLIC_LISTS);
	}

	get selectedListId() {
		return this.$route?.query?.list_id || null;
	}

	get innerTabFilter() {
		return this.filterListsPublic.inner_tab || TabType.BROWSE;
	}

	get innerTabs() {
		return [
			{
				key: TabType.FOLLOWING,
				translation: this.$tc('WEBAPP_LISTS_FOLLOWING'),
			},
			{
				key: TabType.BROWSE,
				translation: this.$tc('WEBAPP_LISTS_BROWSE'),
			},
		] as const;
	}
}
